import { LocationNumbersService } from '../../../services'

const removeNumberFromPool = async function ({ commit, dispatch, state }, payload) {
  const { locationId, poolId, phoneNumber } = payload

  commit('startLoading')
  try {
    const result = await LocationNumbersService.removeNumberFromPool({
      locationId,
      poolId,
      phoneNumber
    })
    await dispatch('fetchNumberPool', {
      numberPools: state.numberPoolIDs,
      locationId: locationId,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
      getPaginatedDataOnly: false,
    })
    commit('stopLoading')
    return result
  } catch (error) {
    commit('stopLoading')
    throw error
  }
}

export default removeNumberFromPool 